<!-- 
  @desc 转移支付
-->
<template>
  <el-container class="main_panel" direction="vertical">
    <el-col :span="24"> <title-bar :titleBar="'转移支付'"></title-bar></el-col>
    <el-container direction="vertical" class="content_panel">
      <el-row :gutter="16" class="search_panel">
        <el-col :span="4" v-loading="!this.dictAll.sportsAuthority">
          <left-select
            :chooseList="this.dictAll.sportsAuthority"
            @chooseValue="chooseValue"
            :orgId="orgId"
          ></left-select>
        </el-col>
        <el-col :span="20">
          <!-- <approve-msg :approveList="approveList"></approve-msg> -->
          <el-row class="list_content">
            <el-tabs v-model="activeTab" class="tab">
              <el-tab-pane v-for="item in tabs" :key="item.name" :label="item.label" :lazy="true" :name="item.name">
                <component
                  v-bind:is="item.content"
                  class="qssComponent"
                  :isHideBreadMenu="true"
                  :orgId="orgId"
                  v-if="activeTab === item.name"
                ></component>
              </el-tab-pane>
            </el-tabs>
          </el-row>
        </el-col>
      </el-row>
    </el-container>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
import TitleBar from "@/components/public/TitleBar.vue";
import LeftSelect from "@/components/public/LeftSelect.vue";
import ApproveMsg from "@/components/public/ApproveMsg.vue";
import Activities from "@/components/game/u/activities/Index.vue";
import Coache from "@/components/coache/Index.vue";
import Reserve from "@/components/reserve/Index.vue";
import Football from "@/components/football/Index.vue";
import YouthTraining from "@/components/youthTraining/Index.vue";
import School from "@/components/school/Index.vue";
import SupportOlympics from "@/components/supportOlympics/Index.vue";
import ImportantProjects from "@/components/importantProjects/Index.vue";

export default {
  components: {
    TitleBar,
    LeftSelect,
    ApproveMsg,
    Activities,
    Coache,
    Reserve,
    Football,
    YouthTraining,
    School,
    SupportOlympics,
    ImportantProjects
  },
  data() {
    return {
      /**表格数据 */
      tableData: [],
      /**审批信息列表 */
      approveList: {},
      /**tab导航配置 */
      activeTab: "activities",
      tabs: [
        {
          label: "U系列赛事活动",
          name: "activities",
          content: Activities
        },
        {
          label: "教练员培训",
          name: "coache",
          content: Coache
        },
        {
          label: "高水平体育后备人才基地",
          name: "reserve",
          content: Reserve
        },
        {
          label: "青训中心",
          name: "youthTraining",
          content: YouthTraining
        },
        {
          label: "青少年足球",
          name: "school",
          content: School
        },
        {
          label: "资助奥运会前8名单位",
          name: "supportOlympics",
          content: SupportOlympics
        },
        {
          label: "重点项目体校布局",
          name: "importantProjects",
          content: ImportantProjects
        }
        // {
        //   label: "足球",
        //   name: "football",
        //   content: Football
        // }
      ],
      /**当前选中单位主键 */
      orgId: ""
    };
  },
  computed: {
    ...mapGetters(["dictAll", "dict"])
  },
  created() {
    /**设置默认选项 */
    this.activeTab = this.$route.query.type ? this.$route.query.type : this.activeTab;
  },
  methods: {
    /**选择左边的项目中心列表 */
    chooseValue(value) {
      this.orgId = value;
    }
  }
};
</script>
